import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useIntl } from "react-intl";
import PdfViewer from "../../components/PdfViewer";

const getPdfUrl = locale =>
  ({
    [locale]:
      "/app/files/tcr-manual-usuario-web-03-01-2022.pdf",
    'en-US': '/app/files/tcr-manual-usuario-web-03-01-2022.pdf'
  }[locale]);

const Manual = () => {
  const { locale } = useIntl();
  const [pdfUrl, setPdfUrl] = useState(getPdfUrl(locale));

  useEffect(() => {
    setPdfUrl(getPdfUrl(locale));
  }, [locale]);

  return (
    <>
      <h1>Manual</h1>

      <div className="content-box manual">
        <PdfViewer url={pdfUrl} title="Manual" />
      </div>
    </>
  );
};

export default Manual;
